import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FnTagComponent } from './fn-tags.component';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { FnScrollbarModule } from './../scrollbar/index';
import { FnToasterModule } from '../toaster/index';

export * from './fn-tags.component';
/**
 * Exports the required FnTagComponent to create Tag Element
 * making them available for import by NgModules that import this module.
 */
@NgModule({
    imports: [CommonModule, FormsModule, NgSelectModule,FnScrollbarModule,FnToasterModule],
    declarations: [FnTagComponent],
    exports: [FnTagComponent]
})
export class FnTagModule {

}
